// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2ArUH","title":"Info_title__1VlfF","links":"Info_links__167uH","link":"Info_link__1bxO9","logo":"Info_logo__205Pt"};